import z from "zod";

/** Which template a usage read asks about. The value is the URL segment the API files it under. */
export enum TemplateUsageKind {
  Team = "team-templates",
  FeeSchedule = "fee-schedule-templates",
}

/**
 * Where an agreement built from a template is in its life. The values are the names the API's
 * `WorkTemplateUsageStage` is sent as.
 */
export enum TemplateUsageStage {
  DraftProposal = "DraftProposal",
  ActiveProposal = "ActiveProposal",
  ArchivedProposal = "ArchivedProposal",
  ActiveWork = "ActiveWork",
  ArchivedWork = "ArchivedWork",
}

/** A party to an agreement: whose list names a template, or which party a counterparty is. */
export enum TemplateUsageSide {
  Client = "Client",
  Vendor = "Vendor",
}

const TemplateCounterpartyJSONZ = z.object({
  side: z.enum(TemplateUsageSide),
  isMasked: z.boolean(),
  legalEntityId: z.string().nullish(),
  name: z.string().nullish(),
});

/**
 * One row of `GET work/{kind}/{templateId}/usages`.
 *
 * The ids are strings rather than `z.uuid()`: the seeded and hand-written GUIDs the API hands back
 * do not all carry RFC 9562's version bits, and one rejected id would discard the whole list.
 */
export const TemplateUsageJSONZ = z.object({
  workAgreementId: z.string(),
  proposalId: z.string(),
  name: z.string(),
  stage: z.enum(TemplateUsageStage),
  proposalStatus: z.string(),
  templateSide: z.enum(TemplateUsageSide),
  counterparty: TemplateCounterpartyJSONZ,
});

export type TemplateUsageJSON = z.infer<typeof TemplateUsageJSONZ>;
